import React from "react";
import { NavLink } from "react-router-dom";
import { greeting } from "../../shared/constants";
import "./Header.css";

export default function Header(props: { theme: any }) {
  const onMouseEnter = (event: { target: any }, color: any) => {
    const el = event.target;
    el.style.backgroundColor = color;
  };

  const onMouseOut = (event: { target: any }) => {
    const el = event.target;
    el.style.backgroundColor = "transparent";
  };
  const theme = props.theme;

  return (
    <div>
      <header className="header">
        <NavLink to="/" className="logo">
          <span className="logo-name">{greeting.logo_name}</span>
        </NavLink>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn">
          <span className="navicon"></span>
        </label>
        <ul className="menu">
          <li>
            <NavLink
              to="/"
              activeStyle={{ fontWeight: "bold" }}
              onMouseEnter={(event: any) =>
                onMouseEnter(event, theme.highlight)
              }
              style={{ color: "#000" }}
              onMouseOut={(event: any) => onMouseOut(event)}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/projects"
              activeStyle={{ fontWeight: "bold" }}
              onMouseEnter={(event: any) =>
                onMouseEnter(event, theme.highlight)
              }
              style={{ color: "#000" }}
              onMouseOut={(event: any) => onMouseOut(event)}
            >
              Projects
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/our-team"
              activeStyle={{ fontWeight: "bold" }}
              onMouseEnter={(event: any) =>
                onMouseEnter(event, theme.highlight)
              }
              style={{ color: "#000" }}
              onMouseOut={(event: any) => onMouseOut(event)}
            >
              Our Team
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact-us"
              activeStyle={{ fontWeight: "bold" }}
              onMouseEnter={(event: any) =>
                onMouseEnter(event, theme.highlight)
              }
              style={{ color: "#000" }}
              onMouseOut={(event: any) => onMouseOut(event)}
            >
              Contact us
            </NavLink>
          </li>
        </ul>
      </header>
    </div>
  );
}
